import React, { useState } from "react";
import getStarted from "../../images/getStarted.svg";

const Image_Base_Url = process.env.REACT_APP_IMAGE_BASE_URL;
const DEFAULT_ICON = "category";

const iconSizePx = (size = 40) => `${size}px`;

function CategoryIconImage({ src, color, size = 40 }) {
  const [error, setError] = useState(false);
  const px = iconSizePx(size);
  if (error) {
    return (
      <span
        style={{ fontSize: px, height: px, color }}
        className="material-icons-outlined"
      >
        {DEFAULT_ICON}
      </span>
    );
  }
  return (
    <img
      style={{ width: px, height: px }}
      alt="categoryIcon"
      src={src}
      onError={() => setError(true)}
    />
  );
}

export const getCategoryIcon = ({ icon, color, size = 40 }) => {
  const px = iconSizePx(size);
  if (!icon) {
    return (
      <span
        style={{ fontSize: px, height: px, color }}
        className="material-icons-outlined"
      >
        {DEFAULT_ICON}
      </span>
    );
  }
  if (icon === "getting-started-icon") {
    return (
      <img
        style={{ width: px, height: px }}
        alt="categoryIcon"
        src={getStarted}
      />
    );
  }
  if (icon.includes("media")) {
    const base = Image_Base_Url?.trim?.() || "";
    if (!base) {
      return (
        <span
          style={{ fontSize: px, height: px, color }}
          className="material-icons-outlined"
        >
          {DEFAULT_ICON}
        </span>
      );
    }
    const sep = base.endsWith("/") ? "" : "/";
    const iconPath = icon.startsWith("/") ? icon.slice(1) : icon;
    return <CategoryIconImage src={`${base}${sep}${iconPath}`} color={color} size={size} />;
  }
  return (
    <span
      style={{ fontSize: px, height: px, color }}
      className="material-icons-outlined"
    >
      {icon}
    </span>
  );
};